import React from 'react';

const YouthAppeals = () => {
  return(
    <div className={'a-routeFadeIn center-content'}>
      <h1>Обращения молодежи</h1>
    </div>
  )
};
export default YouthAppeals